
export default async function FormDetailsFetch( referralUrl: string ): Promise<any> {
  const response = await fetch( `${process.env.REACT_APP_LAMBDA_LEADS_URL}/form-details?referral_url=${referralUrl}`, {
    method: `GET`
  })

  return response?.json()
}
